import FeaturesPlateItemNew from './FeaturesPlateItemNew'

export default FeaturesPlateItemNew
